import React, { useEffect, useState } from "react";
import { SmartTextField } from "./SmartTextField";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { enqueueSnackbar } from "notistack";
import { useCreateGameAward } from "@seabrookstudios/pitch2table";
import { s2Url } from "@seabrookstudios/types";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";

const GameAwardNameTextField = ({ onChange }) => {
  return (
    <SmartTextField
      required
      label="Award Name"
      helperText="The name of the award (e.g., 'Mensa Select', 'Game of the Year')"
      onChange={onChange}
    />
  );
};

const GameAwardSiteUrlTextField = ({ onChange }) => {
  return (
    <SmartTextField
      label="Site URL"
      helperText="The web address for more information about the award (optional)"
      onChange={onChange}
    />
  );
};

const GameAwardYearTextField = ({ onChange }) => {
  return <SmartTextField label="Year" helperText="The year the award was received (e.g., 2023)" onChange={onChange} />;
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {React.ReactNode} [props.CustomControl]
 */
export default function AddGameAwardFullScreenDialog({ gameId, CustomControl = undefined }) {
  const onSuccess = () => {
    enqueueSnackbar("Award added successfully", { variant: "success" });
  };

  const onError = () => {
    enqueueSnackbar("Failed to add award", { variant: "error" });
  };

  const createGameAward = useCreateGameAward(gameId, onSuccess, onError);

  const [name, setName] = useState("");
  const [url, setUrl] = useState(s2Url(""));
  const [year, setYear] = useState("2025");
  const [showOnGamePage, setShowOnGamePage] = useState(true);
  const [canSave, setCanSave] = useState(false);

  const onSaveHandler = async () => {
    await createGameAward.mutateAsync({
      name,
      url,
      year: year ? parseInt(year, 10) : 2025,
      showOnDesignerPage: false,
      showOnGamePage,
    });
    setName("");
    setUrl(s2Url(""));
    setYear("");
    setShowOnGamePage(true);
  };

  useEffect(() => {
    setCanSave(!!(name && name.trim().length > 0));
  }, [name]);

  return (
    <FullScreenDialog
      title="Add Award"
      actionText="save"
      onSaveHandler={onSaveHandler}
      canSave={!canSave}
      isBusy={createGameAward.isPending}
      CustomControl={CustomControl}
    >
      <GameAwardNameTextField onChange={setName} />
      <GameAwardSiteUrlTextField onChange={setUrl} />
      <GameAwardYearTextField onChange={setYear} />
      <Box mt={2}>
        <FormControlLabel
          control={<Checkbox checked={showOnGamePage} onChange={(e) => setShowOnGamePage(e.target.checked)} />}
          label="Show on public page"
        />
      </Box>
    </FullScreenDialog>
  );
}
